import { useTheme } from '@/hooks/useTheme';
import { ProviderMark } from '../icons/provider-marks';
import {
  getModelFamilyName,
  type ModelFamily,
} from '@/lib/subscription-journey/plan-presentation';

const PROVIDER_FOR_FAMILY: Record<ModelFamily, string> = {
  gemini: 'google',
  claude: 'anthropic',
  openai: 'openai',
};

/** Web twin of ModelFamilyRow.tsx (`provider-marks` resolves to its `.web` twin). */
export function ModelFamilyRow({
  family,
  size = 17,
  fontSize = 12,
  color,
}: {
  family: ModelFamily;
  size?: number;
  fontSize?: number;
  color?: string;
}) {
  const { theme } = useTheme();
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        minWidth: 0,
        fontSize,
        fontWeight: 500,
        color: color ?? theme.textSecondary,
      }}
    >
      <span aria-hidden style={{ display: 'inline-flex', width: size, height: size }}>
        <ProviderMark provider={PROVIDER_FOR_FAMILY[family]} size={size} />
      </span>
      <span>{getModelFamilyName(family)}</span>
    </span>
  );
}
